import { render, staticRenderFns } from "./KezakoPage.vue?vue&type=template&id=203e1c32&scoped=true&"
import script from "./KezakoPage.vue?vue&type=script&lang=js&"
export * from "./KezakoPage.vue?vue&type=script&lang=js&"
import style0 from "./KezakoPage.vue?vue&type=style&index=0&id=203e1c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203e1c32",
  null
  
)

export default component.exports